import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    width: '100%',
    marginTop: '1rem',
  },
  toggleButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0.75rem 1rem',
    backgroundColor: '#f8f9fc',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.875rem',
    color: '#424242',
    transition: 'background-color 0.15s ease, border-color 0.15s ease',
    '&:hover': {
      backgroundColor: '#eef1f8',
      borderColor: '#c0c0c0',
    },
  },
  chevron: {
    transition: 'transform 0.2s',
  },
  chevronOpen: {
    transform: 'rotate(180deg)',
  },
  container: {
    marginTop: '0.75rem',
    padding: '1rem',
    backgroundColor: '#fafbfd',
    border: '1px solid #e8e8e8',
    borderRadius: '8px',
  },
  hint: {
    fontSize: '0.8125rem',
    color: '#6c757d',
    marginBottom: '0.75rem',
    lineHeight: 1.5,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    maxHeight: '300px',
    overflowY: 'auto',
    paddingRight: '4px',
  },
  appItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '0.75rem',
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: '#f5f7ff',
      borderColor: '#c5cae9',
    },
  },
  appItemSelected: {
    backgroundColor: '#eef2ff',
    borderColor: '#4c4cff',
    boxShadow: '0 0 0 1px rgba(76, 76, 255, 0.15)',
  },
  appItemDisabled: {
    cursor: 'not-allowed',
    opacity: 0.55,
    '&:hover': {
      backgroundColor: '#fff',
      borderColor: '#e8e8e8',
    },
  },
  appName: {
    fontSize: '0.875rem',
    flex: 1,
    color: '#1a1d29',
    fontWeight: 500,
  },
  appNameCompleted: {
    color: '#065f46',
  },
  statusBadge: {
    fontSize: '0.75rem',
    fontWeight: 600,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    padding: '0.25rem 0.625rem',
    borderRadius: '999px',
  },
  statusSuccess: {
    color: '#065f46',
    backgroundColor: '#ecfdf5',
  },
  statusPending: {
    color: '#92400e',
    backgroundColor: '#fffbeb',
  },
  actions: {
    marginTop: '0.75rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actionButton: {
    background: 'none',
    border: 'none',
    fontSize: '0.8125rem',
    cursor: 'pointer',
    padding: '0.25rem 0',
    fontWeight: 500,
  },
  selectAllButton: {
    color: '#4c4cff',
  },
  clearButton: {
    color: '#6c757d',
  },
  actionButtonDisabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
});

export default useStyles;
